import React, { useState } from "react";
import PropTypes from "prop-types";
import cl from "classnames";

const loadable = (Button) => {
  const Component = ({ className = "", onClick, ...props }) => {
    const [isLoading, setLoading] = useState(false);

    const handleClick = async () => {
      setLoading(true);
      try {
        await onClick();
      } finally {
        setLoading(false);
      }
    };

    return (
      <Button
        className={cl(className, { "vs-btn--submitting": isLoading })}
        disabled={isLoading}
        onClick={handleClick}
        {...props}
      />
    );
  };

  Component.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
  };

  return Component;
};

export default loadable;
